export enum ManualEntryFeatureEnum {
    None = 0,
    ManualEntry = 1,
    MemoView = 2,
    MemoModify = 4,
    FeetAndInches = 32768
}
